import React from 'react'

const TypeContext = React.createContext('')

export default TypeContext
